import type { ProgramConfig } from '../types/schema';
import { ApiError, apiFetch } from './http';
import { buildPortalApiPath } from './routes';

export async function fetchConfig(): Promise<ProgramConfig> {
  const res = await apiFetch(buildPortalApiPath('/config'));
  if (!res.ok) {
    throw new ApiError(`Failed to fetch config: ${res.status}`, res.status);
  }
  return res.json() as Promise<ProgramConfig>;
}

// Only 400 (a slug that cannot name a portal) and 404 (no config) mean the portal does not exist. Any
// other error, including a 403 or 429 from the WAF, is treated as temporary.
export function isPortalNotFound(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 400 || error.status === 404);
}
